import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const getTimeUntilEndOfMonth = () => {
  const now = new Date();
  const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
  const diff = endOfMonth - now;
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const CountdownTimer = () => {
  const [time, setTime] = useState(getTimeUntilEndOfMonth);
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTimeUntilEndOfMonth());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const blocks = [
    { value: time.days, label: t('countdown.days') },
    { value: time.hours, label: t('countdown.hours') },
    { value: time.minutes, label: t('countdown.min') },
    { value: time.seconds, label: t('countdown.sec') },
  ];

  return (
    <div className="inline-flex items-center gap-2" data-testid="countdown-timer">
      {blocks.map((block, i) => (
        <div key={block.label} className="flex items-center gap-2">
          <div className="text-center">
            <span className="block text-[#c8ff00] text-xl md:text-2xl font-bold font-['Syne'] tabular-nums leading-none">
              {String(block.value).padStart(2, '0')}
            </span>
            <span className="block text-white/30 text-[10px] uppercase tracking-wider mt-1">
              {block.label}
            </span>
          </div>
          {i < blocks.length - 1 && (
            <span className="text-white/20 text-lg font-light mb-3">:</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default CountdownTimer;
